import { Text } from '@grupoboticario/flora-react';
import type { UnavailableItem } from 'core/domains/cart';
import { UnavailiableItemsStyles } from 'ui/pages/Cart/components/UnavailableItems/UnavailiableItems.styles';

type UnavailableItemsProps = {
  setOpen: () => void;
};

export const UnavailableItemsMessage = ({ setOpen }: UnavailableItemsProps) => {
  return (
    <>
      <UnavailiableItemsStyles.WarmContainer direction="row" justify="space-between" align="center">
        <div>
          <Text tabIndex={0} size="bodyMediumShort">
            Atenção: alguns itens que estavam em seu pedido foram removidos ou alterados por falta
            de estoque.
          </Text>
        </div>
        <div>
          <UnavailiableItemsStyles.KnowMoreButton
            onClick={() => setOpen()}
            data-unavaliable="true"
            autotagging-flora="on"
            data-flora="button"
            data-flora-text="click:ver-itens-cortados"
            aria-label={'Saber mais sobre itens cortados'}
          >
            Saber mais
          </UnavailiableItemsStyles.KnowMoreButton>
        </div>
      </UnavailiableItemsStyles.WarmContainer>
    </>
  );
};
